import { ColorProps, ListIcon, ListItem, ListItemProps, Text, TypographyProps } from '@chakra-ui/react';

interface ListItemButtonProps {
  icon: any;
  iconColor?: ColorProps['color'];
  iconFontSize?: TypographyProps['fontSize'];
}

export default function ListItemWithIcon({
  icon,
  iconColor = 'blue.500',
  iconFontSize = '2xl',
  children,
  ...listItemProps
}: ListItemButtonProps & ListItemProps) {
  return (
    <ListItem display="flex" alignItems="center" {...listItemProps}>
      <ListIcon as={icon} color={iconColor} fontSize={iconFontSize} />
      <Text as="span" flexGrow={1}>
        {children}
      </Text>
    </ListItem>
  );
}
